import React from "react";
import './Card.scss';

type CardProps = {
    children: React.ReactNode,
    className?: string,
    color?: 'white'|'primary'|'gray',
    noBorderRadiusTop?: boolean,
    noBorderRadiusBottom?: boolean,
    onClick?: () => void,
};

function Card(props: CardProps) {

    return (
        <div className={`card ${props.className ?? ''} ${props.color ?? ''} ${props.noBorderRadiusTop ? 'bottomElement' : ''} ${props.noBorderRadiusBottom ? 'topElement' : ''}`} onClick={props.onClick}>
            {props.children}
        </div>
    );
}

export default Card;
